import dayjs from "dayjs";
import { JobType } from "../../../utils/constants";
import { formatDate } from "../../../utils/helperFunction";
import { Check } from "lucide-react";
import { colors } from "../../../utils/theme";

const JobCard = ({ data, isSelected }) => {
  const {
    title,
    industryType,
    location,
    updatedAt,
    jobType,
    salary,
    refNo,
    companyDetails,
  } = data || {};

  const job = JobType.find((x) => x.value === jobType)?.label;

  return (
    <div
      className={`rounded-lg border border-[#F1F5F9] p-4 hover:bg-light-white-700 w-full cursor-pointer relative
        ${isSelected ? "bg-[#FAFAFA] " : ""}`}
    >
      {isSelected && (
        <div className="w-0 h-0 border-t-[6px] border-t-transparent border-l-[7.5px] border-l-[#F1F5F9] border-b-[6px] border-b-transparent z-50 absolute -right-2"></div>
      )}
      <div className="flex ">
        <p className="flex flex-1 font-semibold text-charcoal text-sm mb-6">
          {title}
        </p>
        <span className="font-normal text-light-black text-[10px]">
          {refNo}
        </span>
      </div>

      <div className="flex flex-col gap-2 mb-6">
        <div className="flex gap-5">
          <span className="text-xs text-light-black w-28">Agency:</span>
          <span className="font-medium text-charcoal text-xs flex-1">
            {companyDetails?.name ?? "N/A"}
          </span>
        </div>
        <div className="flex gap-5">
          <span className="text-xs text-light-black w-28">Location:</span>
          <span className="font-medium text-charcoal text-xs flex-1">
            {location}
          </span>
        </div>
        <div className="flex gap-5">
          <span className="text-xs text-light-black w-28">Industry Type:</span>
          <span className="font-medium text-charcoal text-xs flex-1">
            {industryType}
          </span>
        </div>
        <div className="flex gap-5">
          <span className="text-xs text-light-black w-28">Job Type:</span>
          <span className="font-medium text-charcoal text-xs flex-1">{job}</span>
        </div>
        <div className="flex gap-5">
          <span className="text-xs text-light-black w-28">Salary Range:</span>
          <span className="font-medium text-charcoal text-xs flex-1">
            £{salary.min} - £{salary.max}
          </span>
        </div>
      </div>

      <div className="flex justify-between">
        <span className="font-medium text-[10px] text-light-black italic">
          Posted {formatDate(updatedAt)}
        </span>
        {data?.applied === true && (
          <div className="items-center flex gap-1">
            <div className="flex w-3 h-3 rounded-lg bg-[#2196F3] justify-center items-center">
              <Check width={6} height={6} color={colors.White} />
            </div>
            <span className="font-medium text-[#2196F3] text-[10px] italic">
              Applied {dayjs(data?.appliedAt).fromNow()}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobCard;
